module.exports = __webpack_public_path__ + "02_short_brown.90ab29b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_short_brown.png
// module id = 3hLu
// module chunks = 0